import { AppPlatform, IntegrationPlatform } from 'modules/mobileApps/types';
import { CustomMTAMobileApp } from '../types';

export const mockCustomMtaMobileApps: CustomMTAMobileApp[] = [
  {
    id: 111,
    name: 'test-android',
    packageName: 'test-android',
    platform: AppPlatform.ANDROID,
    storeUrl: 'test-android-store-url',
    pushCustomMTAConfig: {
      id: 665,
      androidUseOsNotifications: false,
      testPushSuccess: false,
      pushPlatform: IntegrationPlatform.GCM,
      customMTAConfigId: 320,
    },
  },
  {
    id: 222,
    name: 'test-ios',
    packageName: 'test-ios',
    platform: AppPlatform.IOS,
    storeUrl: 'test-ios-store-url',
    pushCustomMTAConfig: {
      id: 232,
      androidUseOsNotifications: false,
      testPushSuccess: false,
      pushPlatform: IntegrationPlatform.APNS,
      customMTAConfigId: 589,
    },
  },
];

export const mockCustomMtaAndroidApp = mockCustomMtaMobileApps[0];
export const mockCustomMtaIosApp = mockCustomMtaMobileApps[1];
